export enum MemberPriority {
    Member,
    Priority
}

export enum RetailPriority {
    Retail,
    NonRetail
}
